import { Injectable } from '@angular/core';
import { Headers, RequestOptions, URLSearchParams, Http } from '@angular/http';

import 'rxjs/add/operator/toPromise';

import { TestingBillModel } from '../model/index';

@Injectable()
export class TestingBillService {
    private headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'q=0.8;application/json;q=0.9' });
    private testingbillUrl = 'api/testingBill';  // URL to web api

    constructor(private http: Http) { }

    private extractData(res: any) {
        let body = res.json();
        return body || [];
    }

    getTestingbillList(query: any): Promise<TestingBillModel[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.testingbillUrl}/getTestingbillList`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

     getTestingbillDetailList(query: any): Promise<TestingBillModel[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.testingbillUrl}/getTestingbillDetailList`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

     addTestingbill(query: any): Promise<TestingBillModel[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.testingbillUrl}/addTestingbill`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

     deleteGridList(rowData: any): Promise<TestingBillModel> {
        const url = `${this.testingbillUrl}/deleteGridList`;
        return this.http
            .post(url, $.param(rowData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as TestingBillModel)
            .catch(this.handleError);
    }

    getTestingbill(client_id: number): Promise<TestingBillModel> {
        const url = `${this.testingbillUrl}/clientList?client_id=${client_id}`;
        return this.http.get(url)
            .toPromise()
            .then(response => response.json().data as TestingBillModel)
            .catch(this.handleError);
    }

    getTestingbillClientList(): Promise<any> {
        const url = `${this.testingbillUrl}/getTestingbillClientList`;
        return this.http.get(url)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    getTestingtypeList(): Promise<any> {
        const url = `${this.testingbillUrl}/getTestingtypeList`;
        return this.http.get(url)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    getTestingFees(rowData: any): Promise<TestingBillModel> {
        const url = `${this.testingbillUrl}/getTestingFees`;
        return this.http
            .post(url, $.param(rowData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as TestingBillModel)
            .catch(this.handleError);
    }

    deleteTestingbill(rowData: any): Promise<TestingBillModel> {
        const url = `${this.testingbillUrl}/deleteTestingbill`;
        return this.http
            .post(url, $.param(rowData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as TestingBillModel)
            .catch(this.handleError);
    }

    addUpdateTestingbill(testbilldetail: any): Promise<TestingBillModel> {

        const url = `${this.testingbillUrl}/addUpdateTestingbill`;

        return this.http
            .post(url, $.param(testbilldetail), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as TestingBillModel)
            .catch(this.handleError);
    }

    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error); // for demo purposes only
        return Promise.reject(error.message || error);
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/services/testingBill.service.ts